@use '@lib/assets/styles/main.scss' as *;
.fieldRoot {
  background: $gray0;
  border: 1px solid $gray200;
  padding: 12px 24px 12px 16px;
  border-radius: 8px;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 16px;
  transition: background-color 0.3s ease;
  &.fieldRootEnabled {
    background: $blue20;
  }
}

.fieldToggleFormItem {
  padding: 0;
}

.fieldContent {
  min-height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fieldTitle {
  display: flex;
  align-items: center;
  gap: 4px;
}

.fieldTitleIcon {
  display: block;
}

.fieldTitleLock {
  margin-left: auto;
  margin-right: -8px;
  display: inline-flex;
}

.fieldDescription {
  color: $gray700;
}

.fieldChildren {
  padding-top: 16px;
}
